export default {
  xl: "@media screen and (max-width: 1300px)",
  l: "@media screen and (max-width: 992px)",
  m: "@media screen and (max-width: 768px)",
  s: "@media screen and (max-width: 576px)",
  xs: "@media screen and (max-width: 320px)",
};
